module.exports = "https://bin.bnbstatic.com/_next/static/images/usdt_web_cn-dac254bb7714c27ea2c8172cc41480ff.png";